import React, { ChangeEventHandler, useRef } from "react"
import { useTranslation } from "react-i18next"
import PhoneAndroidOutlinedIcon from "@mui/icons-material/PhoneAndroidOutlined"
import PhotoLibraryOutlinedIcon from "@mui/icons-material/PhotoLibraryOutlined"
import FlipCameraIosOutlinedIcon from "@mui/icons-material/FlipCameraIosOutlined"
import Theme from "../../library/Theme"
import {Fade, Stack} from "@mui/material"
import BigButton from "../buttons/BigButton"

interface CameraControlsProps {
  theme: Theme
  canSwitchCamera: boolean
  switchCamera: () => void
  switchDevice: () => void
  handleUserSelectedImage: (file: File) => void
}

export default function CameraControls({
  theme,
  canSwitchCamera,
  switchCamera,
  switchDevice,
  handleUserSelectedImage,
}: CameraControlsProps) {
  const { t } = useTranslation()
  const fileInput = useRef<HTMLInputElement>(null)

  const showImageChooser = () => {
    if (!fileInput || !fileInput.current) {
      return
    }
    fileInput.current.click()
  }

  const handleChosenImage: ChangeEventHandler<HTMLInputElement> = (e) => {
    let file = e.target.files?.item(0) ?? null
    if (!file) {
      return
    }

    handleUserSelectedImage(file)
  }


  return (
    <>
      <input
        type="file"
        ref={fileInput}
        onChange={handleChosenImage}
        onClick={(event) => {
          event.currentTarget.value = ""
        }}
        accept="image/jpg,image/jpeg,image/png"
        hidden
      />

      <Fade
        in
        timeout={500}
      >
        <Stack
          spacing={2}
          justifySelf="center"
          sx={{ mt: 3, color: theme.textColor }}
        >
          {/*<BigButton variant="text" size="small" onClick={showImageChooser}>*/}
          {/*  <PhotoLibraryOutlinedIcon sx={{mr: 1}}/>*/}
          {/*  {t("capture.library")}*/}
          {/*</BigButton>*/}

          {canSwitchCamera ? (
            <BigButton variant="text" size="small" onClick={switchCamera}>
              <FlipCameraIosOutlinedIcon sx={{mr: 1}}/>
              {t("capture.switchCamera")}
            </BigButton>
          ) : (
            <BigButton variant="text" size="small" onClick={switchDevice}>
              <PhoneAndroidOutlinedIcon sx={{mr: 1}}/>
              {t("common.switchDevice")}
            </BigButton>
          )}
        </Stack>
      </Fade>
    </>
  )
}
